import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import Card from "../Card/Card";
import "./Shadow.css";
import { Copy } from 'lucide-react';
const Shadow = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);
  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="carve-shadows">
        <div className="carve-shadow-all">Shadow all</div>
        <div className="carve-shadow-head" style={{ background: 'none', border: 'none', color: 'inherit' }}>Shadow header</div>
        <div className="carve-shadow-foot">Shadow footer</div>
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <pre>
            <code>
              <>
                <span className='cn'>&lt;div</span>
                <span className='cln'> className="</span>
                <span className='cn'>carve-shadows</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> className="</span>
                <span className='cn'>carve-shadow-all</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>Shadow all<span className='cn'>&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> className="</span>
                <span className='cn'>carve-shadow-head</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>Shadow header<span className='cn'>&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> className="</span>
                <span className='cn'>carve-shadow-foot</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>Shadow footer<span className='cn'>&lt;/div&gt;</span>
              </>
              <br />
              <>
                <span className='cn'>&lt;/div&gt;</span>
              </>
            </code>

          </pre>
        </div>
        <button className="copy-button" onClick={copySnippet}>
          <Copy />
        </button>
      </div>
    </motion.div>
  );
}

const ShadowCard = () => {
  return (
    <Card CardTitle="Shadow"
      CardBody={<Shadow />}
    />
  );
}
export default ShadowCard;